/* Black Friday 2.0 — the three things the widget's own config cannot express.

   1. Option 1 is necklace ONLY. The widget floors the first bar at one flavour
      (`refills: (C0.b1 && C0.b1.refills) || 1` turns a 0 into a 1), so the
      count is forced here, on the live CONFIG object the widget reads on every
      render.
   2. The free 2nd flavor is earned by subscribing, not by picking option 2.
      freeRefills is a static property of the bar, so it is driven off the
      Subscribe & Save state instead and the widget re-rendered when it flips.
   3. The widget's applyPageCodes MERGES discount codes into whatever the cart
      already carries, it does not replace them. A shopper who saw the previous
      offer still has EBF-N / EBF-R / EBF-RS on their cart, and those are
      larger amounts on the same products — they would win and the necklace
      would ring up at $14.99 instead of $25.95. Retired offer codes are
      stripped here. Codes the shopper entered themselves are left alone.

   Also hides Subscribe & Save on option 1 — there is no flavour to subscribe
   to, subscriptions are flavour-only. */
(function () {
  'use strict';
  if (location.pathname.indexOf('breathefree-2-0-resistance-necklace-early-black-friday') === -1) return;

  var WANT = ['NBF-N', 'NBF-R', 'NBF-RS'];
  var RETIRED = /^(EBF-|BFSTACK-|BF2STACK-|BF2-GIFT$)/i;

  var CSS =
    '.rsb.ebf-necklace-only .rsb-subs{display:none!important}' +
    '.rsb.ebf-necklace-only .rsb-flvwrap{display:none!important}' +
    '.rsb .rsb-select[data-rsb-pick="color"]{display:none!important}' +
    '.rsb .rsb-sg__grid{display:flex!important;flex-wrap:wrap}' +
    '.rsb .rsb-sg__grid > *{flex:1 1 0;min-width:0}';
  var st = document.createElement('style');
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);
  document.addEventListener('DOMContentLoaded', function () { if (document.body) document.body.appendChild(st); });

  /* ------------------------- 1 + 2: bar shape ------------------------- */
  var api = null;

  function sync(allowRender) {
    if (!api) return;
    var bars = api.config && api.config.bars;
    var S = api.state;
    if (!bars || !S) return;

    var changed = false;

    if (bars[0] && (bars[0].refills !== 0 || bars[0].freeRefills !== 0)) {
      bars[0].refills = 0;
      bars[0].freeRefills = 0;
      changed = true;
    }

    if (bars[1]) {
      if (bars[1].refills !== 1) { bars[1].refills = 1; changed = true; }
      var want = S.subscribe ? 1 : 0;
      if (bars[1].freeRefills !== want) { bars[1].freeRefills = want; changed = true; }
    }

    var root = document.querySelector('.rsb');
    if (root) root.classList.toggle('ebf-necklace-only', S.bar === 'reset');

    if (changed && allowRender && typeof api.render === 'function') {
      try { api.render(); } catch (e) {}
      if (root) root.classList.toggle('ebf-necklace-only', S.bar === 'reset');
    }
  }

  function later() { setTimeout(function () { sync(true); }, 0); }

  /* ----------------------- 3: discount hygiene ----------------------- */
  var fixing = false, fixes = 0, windowStart = Date.now();

  function fixCodes() {
    if (fixing) return;
    if (Date.now() - windowStart > 60000) { windowStart = Date.now(); fixes = 0; }
    if (fixes >= 6) return;                       /* never fight another script in a loop */
    fixing = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.item_count) return;          /* nothing to discount yet */
        var have = (c.discount_codes || []).map(function (d) { return String(d.code || ''); });
        var keep = have.filter(function (x) { return !RETIRED.test(x); });
        WANT.forEach(function (w) {
          if (keep.map(function (x) { return x.toUpperCase(); }).indexOf(w) === -1) keep.push(w);
        });
        var same = keep.length === have.length && keep.every(function (x, i) { return x === have[i]; });
        if (same) return;
        fixes++;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: keep.join(',') })
        });
      })
      .catch(function () {})
      .then(function () { fixing = false; });
  }

  var pending = null;
  function fixSoon() { clearTimeout(pending); pending = setTimeout(fixCodes, 700); }

  var of = window.fetch;
  window.fetch = function (u, o) {
    var url = (typeof u === 'string') ? u : (u && u.url) || '';
    var p = of.apply(this, arguments);
    if (/\/cart\/(add|update|change|clear)/.test(url)) { try { p.then(fixSoon, function () {}); } catch (e) {} }
    return p;
  };

  /* ----------------------------- wiring ------------------------------ */
  function attach() {
    api = window.BFResetStack;
    if (!api) return false;
    sync(true);
    /* Set the shape in the CAPTURE phase, before the widget's own click handler
       renders. Doing it afterwards made the box lay out twice — the widget's
       render, then ours ~300ms later — which is what read as a glitch. */
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest && e.target.closest('.rsb [data-rsb-bar], .rsb [data-rsb-subs-toggle]');
      if (!el || !api) return;
      var bars = api.config && api.config.bars, S = api.state;
      if (!bars || !S) return;
      var nextBar = S.bar, nextSub = S.subscribe;
      if (el.matches('[data-rsb-bar]')) nextBar = el.getAttribute('data-rsb-bar');
      else nextSub = !S.subscribe;
      if (bars[0]) { bars[0].refills = 0; bars[0].freeRefills = 0; }
      if (bars[1]) { bars[1].refills = 1; bars[1].freeRefills = nextSub ? 1 : 0; }
      var root = document.querySelector('.rsb');
      if (root) root.classList.toggle('ebf-necklace-only', nextBar === 'reset');
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.rsb')) later();
    }, false);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.rsb')) later();
    }, false);
    setInterval(function () { sync(true); }, 1000);
    fixSoon();
    return true;
  }

  function start() {
    if (attach()) return;
    var n = 0;
    var iv = setInterval(function () { if (attach() || ++n > 60) clearInterval(iv); }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();